<div class="fixed bottom-[calc(env(safe-area-inset-bottom)+6px)] left-0 right-0 z-[2200] px-2.5">
  <nav class="h-[62px] rounded-[17px] border border-white/40 bg-[linear-gradient(180deg,rgba(246,250,247,0.82)_0%,rgba(232,240,235,0.78)_100%)] shadow-[0_8px_26px_rgba(8,19,25,0.22)] backdrop-blur-xl">
    <ul class="grid h-full grid-cols-5 items-center gap-1 px-1">
        <li class="h-full">
          <a class="bottom-nav__link" routerLink="/search" routerLinkActive="bottom-nav__link--active">
            <span class="bottom-nav__icon-shell">
              <svg class="h-[21px] w-[21px]" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <use [attr.xlink:href]="ImageManager.searchIcon" />
              </svg>
            </span>
          </a>
        </li>

        <li class="h-full">
          <a class="bottom-nav__link" routerLink="/map" routerLinkActive="bottom-nav__link--active">
            <span class="bottom-nav__icon-shell">
              <svg class="h-[21px] w-[21px]" fill="none" stroke="currentColor" stroke-width="1.9"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <use [attr.xlink:href]="ImageManager.mapIcon" />
              </svg>
            </span>
          </a>
        </li>

        <li class="h-full">
          <a class="bottom-nav__link bottom-nav__link--center no-context-menu"
            routerLink="/"
            routerLinkActive="bottom-nav__link--active"
            [routerLinkActiveOptions]="{ exact: true }">
            <span class="bottom-nav__icon-shell">
              <img alt="Explore icon" class="bottom-nav__center-logo"
                [src]="ImageManager.getLogoBottomBarByTerritoryCode()">
            </span>
          </a>
        </li>

        <li class="h-full">
          <a class="bottom-nav__link" routerLink="/explore" routerLinkActive="bottom-nav__link--active">
            <span class="bottom-nav__icon-shell">
              <svg class="h-[21px] w-[21px]" fill="none" stroke="currentColor" stroke-width="2"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <use [attr.xlink:href]="ImageManager.exploreIcon" />
              </svg>
            </span>
          </a>
        </li>

        <li class="h-full">
          <a class="bottom-nav__link"
            routerLink="/profile"
            routerLinkActive="bottom-nav__link--active"
            longPress
            (longPressEmitter)="onLongPress()">
            <span class="bottom-nav__icon-shell">
              <svg class="h-[21px] w-[21px]" fill="none" stroke="currentColor" stroke-width="2"
                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <use [attr.xlink:href]="ImageManager.userIcon" />
              </svg>
            </span>
          </a>
        </li>
    </ul>
  </nav>
</div>
